import * as Sentry from '@sentry/react'
import { platform } from '../../device/platform'
import packageJson from '../../../../../package.json'

const { version } = packageJson

const isNative = platform !== 'web'

const DSN = isNative
  ? 'https://184f8b7605c6600943bb169d7fcebff5@logs.auravant.com/96'
  : 'https://96c8f6a013a8416cb3741c78317c45f6@logs.auravant.com/79'

const IGNORED_ERRORS = [
  'Failed to load script',
  'Loading chunk',
  'Network request failed',
  'Failed to fetch',
  'Load failed',
  'AbortError',
  'TypeError: cancelled',
  'TypeError: Cancelled'
]

export default (): void => {
  try {
    
    const integrations: any[] = []

    try {
      const { moduleMetadataIntegration } = require('@sentry/core')
      if (typeof moduleMetadataIntegration === 'function') {
        integrations.push(moduleMetadataIntegration())
      }
    } catch (_) { /* not available in this Sentry version */ }
  
    // BrowserTracing solo en web — en mobile genera overhead en cada fetch/navigation
    if (!isNative) {
      integrations.push(
        new Sentry.BrowserTracing({
          tracePropagationTargets: [window.location.origin]
        })
      )
    }
  
    Sentry.init({
      dsn: DSN,
      environment: process.env.NODE_ENV ?? 'development',
      release: version,
      integrations,
      initialScope: {
        tags: {
          app_version: version,
          project_id: process.env.PROJECT_ID ?? 'unknown',
          app_identifier: process.env.GOOGLE_PLAY_PACKAGE_NAME ?? process.env.APPLE_BUNDLE_ID ?? 'unknown'
        }
      },
      transport: isNative
        ? Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport)
        : Sentry.makeFetchTransport,
  
      // Performance: 0% en mobile, 10% en web
      tracesSampleRate: isNative ? 0 : 0.1,
  
      // Limitar eventos por segundo para no saturar en ráfagas
      maxBreadcrumbs: isNative ? 20 : 100,
  
      // No enviar eventos de transacciones default en mobile
      enableTracing: !isNative,
  
      beforeSend: (event) => {
        try {
          // Filtrar errores de red/carga que no son accionables
          const message = event.exception?.values?.[0]?.value ?? event.message ?? ''
          if (IGNORED_ERRORS.some(ignored => message.includes(ignored))) {
            return null
          }
  
          // Enriquecer con metadata de MFE
          event.tags = event.tags ?? {}
          const frames = event?.exception?.values?.[0]?.stacktrace?.frames ?? []
          const frame = ([...frames].reverse().find(
            (f: any) => f.module_metadata?.mfe_name != null && f.module_metadata.mfe_id_version
          )) ?? {} as any
  
          if (frame.module_metadata !== undefined) {
            event.tags.mfe_name = frame.module_metadata.mfe_name
            event.tags.mfe_version = frame.module_metadata.version
          }
          if (event.extra?.__serialized__ != null) {
            event.tags.mfe_name = (event.extra.__serialized__ as any).mfe_name
            event.tags.mfe_version = (event.extra.__serialized__ as any).mfe_version
          }
        } catch (err) {
          // Silenciar errores del propio beforeSend
        }
        return event
      }
    })
  } catch (error) {
    console.error('Failed to initialize Sentry', error)
  }
}
